import { useNode } from "@craftjs/core";
import * as React from "react";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
} from "@/components/editor/shared/block-wrapper";
import { PaddingWrapper } from "@/components/editor/themes/crosby/constants";

import { Wrapper } from "./divider-picture-styles";

type DividerPictureProps = {
  children: React.ReactNode;
};

export default function DividerPicture({ children }: DividerPictureProps) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  return (
    <BlockBackgroundColorWrapper ref={connect} id={nodeId}>
      <PaddingWrapper>
        <BlockMaxWidthWrapper>
          <Wrapper>{children}</Wrapper>
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

DividerPicture.craft = {
  isCanvas: true,
  custom: {
    displayName: "Divider & Picture",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
